import adminAPI from "../../api/apiAdmin";

class AdminAuditLogService {
    static async getAll(params = {}) {
        const response = await adminAPI.get("/admin/audit-logs", { params });
        return response.data;
    }

    static async getDetail(id) {
        const response = await adminAPI.get(`/admin/audit-logs/${id}`);
        return response.data;
    }

    static async getFilterOptions() {
        const response = await adminAPI.get("/admin/audit-logs/filters");
        return response.data;
    }
}

export default AdminAuditLogService;
